import { connect } from 'react-redux'
import { SetState as SetCMAState } from '#/store/actions/cma'
import { SetState } from '#/store/actions/compare'
import { ShareLink } from '#/store/actions/user'
import { AddToList, RemoveFromList } from '#/store/actions/workspace'
import { isInList } from '#/store/selectors/workspace'
import Actions from './Actions'
import type { OwnProps } from './types'

const mapStateToProps = (state: TopHap.StoreState, ownProps: OwnProps) => ({
  comparableIds: state.compare.preferences.ids,
  isFavorite: isInList(state, ownProps.property.id, 'favorites'),
  isHidden: isInList(state, ownProps.property.id, 'hidden'),
  cmaData: state.cma.preferences.data,
  user: state.user.info
})

const mapDispatchToProps = {
  addToList: AddToList,
  removeFromList: RemoveFromList,
  shareLink: ShareLink,
  setComparableIds: (ids: string[]) => SetState({ option: 'preferences.ids', value: ids }),
  setCMAData: (data: TopHap.CMAInfo[]) => SetCMAState({ option: 'preferences.data', value: data })
}

export default connect(mapStateToProps, mapDispatchToProps)(Actions)
